import config from "@/config"
import http from "@/utils/request"

export default {
    getDeviceProperty: {
        url: `${config.API_URL}/aiValve/deviceProperty/`,
        name: "查询aiValve设备最新属性数据",
        get: async function (deviceNumber) {
            return await http.get(this.url + deviceNumber);
        },
    },
    erasure: {
        url: `${config.API_URL}/aiValve/service/erasure/`,
        name: "aiValve消音",
        post: async function (deviceNumber) {
            return await http.post(this.url + deviceNumber);
        },
    },
    otaUpgrade: {
        url: `${config.API_URL}/aiValve/service/otaUpgrade/`,
        name: "aiValve OTA升级",
        post: async function (deviceNumber) {
            return await http.post(this.url + deviceNumber);
        },
    },
    selfcheck: {
        url: `${config.API_URL}/aiValve/service/selfcheck/`,
        name: "aiValve自检",
        post: async function (deviceNumber) {
            return await http.post(this.url + deviceNumber);
        },
    },
    setConstantCurrentTimeout: {
        url: `${config.API_URL}/aiValve/service/setConstantCurrentTimeout/`,
        name: "aiValve设置恒流超时时间",
        post: async function (deviceNumber, data) {
            return await http.post(this.url + deviceNumber, data);
        },
    },
    setOverpressurePara: {
        url: `${config.API_URL}/aiValve/service/setOverpressurePara/`,
        name: "aiValve设置超压参数",
        post: async function (deviceNumber, data) {
            return await http.post(this.url + deviceNumber, data);
        },
    },
    setOvertemperaturePara: {
        url: `${config.API_URL}/aiValve/service/setOvertemperaturePara/`,
        name: "aiValve设置超温参数",
        post: async function (deviceNumber, data) {
            return await http.post(this.url + deviceNumber, data);
        },
    },
    setPressureMaintainingTest: {
        url: `${config.API_URL}/aiValve/service/setPressureMaintainingTest/`,
        name: "aiValve设置保压测试",
        post: async function (deviceNumber) {
            return await http.post(this.url + deviceNumber);
        },
    },
    setUnderpressurePara: {
        url: `${config.API_URL}/aiValve/service/setUnderpressurePara/`,
        name: "aiValve设置欠压参数",
        post: async function (deviceNumber, data) {
            return await http.post(this.url + deviceNumber, data);
        },
    },
    setValveCloseTime: {
        url: `${config.API_URL}/aiValve/service/setValveCloseTime/`,
        name: "aiValve设置定时关阀时间",
        post: async function (deviceNumber, data) {
            return await http.post(this.url + deviceNumber, data);
        },
    },
    valveControl: {
        url: `${config.API_URL}/aiValve/service/valveControl/`,
        name: "aiValve阀门控制",
        post: async function (deviceNumber, data) {
            return await http.post(this.url + deviceNumber, data);
        },
    },
}
